import { cn } from '@ui/lib/utils'
import NextImage, { ImageProps as NextImageProps } from 'next/image'

interface ImageProps extends Omit<NextImageProps, 'alt'> {
  alt: string // Rendre alt obligatoire
  aspectRatio?: '16/9' | '4/3' | '1/1' | 'auto'
}

export function Image({ aspectRatio = 'auto', className, ...props }: ImageProps) {
  const aspectClasses = {
    '16/9': 'aspect-video',
    '4/3': 'aspect-4/3',
    '1/1': 'aspect-square',
    auto: '',
  }

  if (props.src === undefined || props.src === null || props.src === '') {
    return null
  }

  return (
    <div className={cn('relative overflow-hidden', aspectClasses[aspectRatio])}>
      <NextImage
        unoptimized
        className={cn('object-cover', className)}
        placeholder="blur"
        blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN8/5+hHgAHggJ/PchI7wAAAABJRU5ErkJggg=="
        {...props}
      />
    </div>
  )
}

Image.displayName = 'Image'
